import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/Works.css';
import WebWorks from './WebWorks';

export default function Works() {
    return (
        <section id='works' className='works'>
            <Container>
                <h1 className='text-center'>I've done the works below recently</h1>
                <hr />
                <WebWorks></WebWorks>
                <hr />
            </Container>
        </section>
    );
};